
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import axios from 'axios';

import SakuraFall from '@/components/SakuraFall.vue';
import TheHeader from '@/components/TheHeader.vue';
import TheError from '@/components/TheError.vue';
import DashboardOverview from '@/components/DashboardOverview.vue';
import ServersTable from '@/components/ServersTable.vue';
import UpdateTime from '@/components/UpdateTime.vue';
import ServersCard from '@/components/ServersCard.vue';
import TheFooter from '@/components/TheFooter.vue';
import { loadTrafficBaseline, loadTrafficConfig, setTrafficServers } from '@/components/useTraffic';
import { BoxItem, StatusItem } from '@/types';

/** 基线只在账单日变动，10 分钟重拉一次即可覆盖“页面长期开着跨月”的情况 */
const BASELINE_INTERVAL = 10 * 60 * 1000;

export default defineComponent({
  name: 'App',
  components: {
    SakuraFall,
    TheHeader,
    TheError,
    DashboardOverview,
    ServersTable,
    ServersCard,
    TheFooter,
    UpdateTime
  },
  setup() {
    const servers = ref<Array<StatusItem | BoxItem>>();
    const updated = ref<number>();
    const { interval } = window.__PRE_CONFIG__;
    let timer: number;
    let baselineTimer: number;
    const runFetch = () => axios.get('json/stats.json')
      .then(res => {
        servers.value = res.data.servers;
        setTrafficServers(res.data.servers);
        updated.value = Number(res.data.updated);
      })
      .catch(err => console.log(err));
    onMounted(() => {
      runFetch();
      timer = setInterval(runFetch, interval * 1000);
      loadTrafficConfig();
      loadTrafficBaseline();
      baselineTimer = setInterval(loadTrafficBaseline, BASELINE_INTERVAL);
    });
    onBeforeUnmount(() => {
      clearInterval(timer);
      clearInterval(baselineTimer);
    });
    return {
      servers,
      updated
    };
  }
});
